/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_BasicInputs */

const en_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic`)
};

const de_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basis`)
};

const fr_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basique`)
};

const es_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Básico`)
};

const it_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base`)
};

const nl_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basis`)
};

const pl_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podstawowy`)
};

const fi_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perus`)
};

const da_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basis`)
};

const sv_settings_basic = /** @type {(inputs: Settings_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundläggande`)
};

/**
* | output |
* | --- |
* | "Basic" |
*
* @param {Settings_BasicInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_basic = /** @type {((inputs?: Settings_BasicInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_BasicInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_basic(inputs)
	if (locale === "fr") return fr_settings_basic(inputs)
	if (locale === "es") return es_settings_basic(inputs)
	if (locale === "it") return it_settings_basic(inputs)
	if (locale === "nl") return nl_settings_basic(inputs)
	if (locale === "pl") return pl_settings_basic(inputs)
	if (locale === "fi") return fi_settings_basic(inputs)
	if (locale === "da") return da_settings_basic(inputs)
	if (locale === "sv") return sv_settings_basic(inputs)
	return en_settings_basic(inputs)
});